import React from "react";
import "./produk.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Apartprimrose3brimages from "./apartprimrose3br.js";
import Apartprimrose4brimages from "./apartprimrose4br.js";
import Apartspimages from "./apartspringlakestudio.js";
import Apartsp2brimages from "./apartsp2br.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsUpDownLeftRight } from "@fortawesome/free-solid-svg-icons";
import { faBed } from "@fortawesome/free-solid-svg-icons";
import { faShower } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const produk = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const spstudiowa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Springlake)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const sp2brwa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Springlake+2BR)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const pr3brwa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Primrose)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const pr4brwa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Primrose+4BR)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };

  return (
    <div className="container-card">
      <div className="kartu">
        <Slider {...settings}>
          {Apartspimages.map((image, index) => (
            <img
              className="kartugambar"
              key={index}
              src={image}
              alt={`springlake ${index + 1}`}
            />
          ))}
        </Slider>
        <div className="container-title-card">
          <div className="titlecard">
            <div className="judul-rumah">The SpringLake </div>
            <div className="sub-judul-rumah">Siap Huni</div>
            {/* <div className="cicilan">
              <div className="angka">2.3 Juta/Bulan</div>
            </div> */}
          </div>
        </div>
        <hr color="black" />
        <div className="deskripsi-cluster">
          <div className="deskripsi">
            Apartemen The SpringLake ini menawarkan tiga pilihan tipe unit,
            yaitu Studio, 2 Bedroom, dan 3 Bedroom.
          </div>
        </div>
        {/* 
        <div className="gridspek">
          <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
          <span> : 25,56m²</span>
          <FontAwesomeIcon icon={faBed} />
          <span>: 1</span>
          <FontAwesomeIcon icon={faShower} />
          <span>: 1</span>
        </div> */}
        <div className="containerwhatsapp">
          <button onClick={spstudiowa} className="whatsapp">
            <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
          </button>
        </div>
      </div>
      {/* <div className="kartu">
        <Slider {...settings}>
          {Apartsp2brimages.map((image, index) => (
            <img
              className="kartugambar"
              key={index}
              src={image}
              alt={`springlake ${index + 1}`}
            />
          ))}
        </Slider>
        <div className="container-title-card">
          <div className="titlecard">
            <div className="judul-rumah">Spring Lake 2+1BR</div>
            <div className="sub-judul-rumah">Siap Huni</div>
            {/* <div className="cicilan">
              <div className="angka">3.6 Juta/Bulan</div>
            </div> */}
      {/* </div>
        </div> */}
      {/* <hr color="black" />
        <div className="gridspek">
          <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
          <span> : 45,12m²</span>
          <FontAwesomeIcon icon={faBed} />
          <span>: 2+1</span>
          <FontAwesomeIcon icon={faShower} />
          <span>: 1</span>
        </div> */}
      {/* <div className="containerwhatsapp">
          <button onClick={sp2brwa} className="whatsapp">
            <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
          </button>
        </div>
      </div> */}
      <div className="kartu">
        <Slider {...settings}>
          {Apartprimrose3brimages.map((image, index) => (
            <img
              className="kartugambar"
              key={index}
              src={image}
              alt={`springlake ${index + 1}`}
            />
          ))}
        </Slider>
        <div className="container-title-card">
          <div className="titlecard">
            <div className="judul-rumah">The Primrose</div>
            <div className="sub-judul-rumah">Siap Huni</div>
            {/* <div className="cicilan">
              <div className="angka">9 Juta/Bulan</div>
            </div> */}
          </div>
        </div>
        <hr color="black" />
        <div className="deskripsi-cluster">
          <div className="deskripsi">
            Apartemen The Primrose Condovilla ini menawarkan tiga pilihan tipe
            unit, yaitu Type 95, Type 114, dan Type 137.
          </div>
        </div>
        {/* 
        <div className="gridspek">
          <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
          <span> : 99,78m²</span>
          <FontAwesomeIcon icon={faBed} />
          <span>: 3+1</span>
          <FontAwesomeIcon icon={faShower} />
          <span>: 2+1</span>
        </div> */}
        <div className="containerwhatsapp">
          <button onClick={pr3brwa} className="whatsapp">
            <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
          </button>
        </div>
      </div>
      {/* <div className="kartu">
        <Slider {...settings}>
          {Apartprimrose4brimages.map((image, index) => (
            <img
              className="kartugambar"
              key={index}
              src={image}
              alt={`springlake ${index + 1}`}
            />
          ))}
        </Slider>
        <div className="container-title-card">
          <div className="titlecard">
            <div className="judul-rumah">Primrose 4BR</div>
            <div className="sub-judul-rumah">Free Furnished dan Siap Huni</div>
            {/* <div className="cicilan">
              <div className="angka">12 Juta/Bulan</div>
            </div> */}
      {/* </div>
        </div> */}
      {/* <hr color="black" />
        <div className="gridspek">
          <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
          <span> : 121,52m²</span>
          <FontAwesomeIcon icon={faBed} />
          <span>: 4+1</span>
          <FontAwesomeIcon icon={faShower} />
          <span>: 2+1</span>
        </div> */}
      {/* <div className="containerwhatsapp">
          <button onClick={pr4brwa} className="whatsapp">
            <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
          </button>
        </div>
      </div> */}
    </div>
  );
};

export default produk;
